import { createClient } from "@supabase/supabase-js";
import { config } from "./config";

// Browser Supabase client. RLS applies to everything it touches. Passwordless
// magic-link / OTP auth; the session is detected from the redirect URL.
export const supabase = createClient(config.supabaseUrl, config.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // "implicit" carries the token in the login link itself, so it works even
    // when the email opens in a different browser than the one that requested it
    // (very common when tapping links from inside a text/chat app). This avoids
    // the PKCE "asked for my email again" loop.
    flowType: "implicit",
  },
});

export async function accessToken(): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}
